// Stage 2B — worldwide phone display formatting + soft validity hint.
// Never rewrites stored data; purely presentational. Uses libphonenumber-js.
import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Format a phone number for display without ever mutating stored data.
 * @param {string} raw - the number exactly as the owner typed it
 * @param {string} [iso] - optional ISO-2 country code to help parse local numbers
 * @returns {{ formatted: string, valid: boolean, parsed: boolean }}
 */
export function formatPhone(raw, iso) {
  const input = (raw || '').trim();
  if (!input) return { formatted: '', valid: false, parsed: false };
  try {
    const pn = parsePhoneNumberFromString(input, iso ? iso.toUpperCase() : undefined);
    if (!pn) return { formatted: input, valid: false, parsed: false };
    return { formatted: pn.formatInternational(), valid: pn.isValid(), parsed: true };
  } catch {
    return { formatted: input, valid: false, parsed: false };
  }
}
